import i18n from "../../i18n"

export const MONITOR_COLUMNS = {
  NAME: {
    id: 'NAME',
    label: i18n.t('Name'),
    path: 'name'
  },
  DESCRIPTION: {
    id: 'DESCRIPTION',
    label: i18n.t('Description'),
    path: 'description'
  },
  FLEET: {
    id: 'FLEET',
    label: i18n.t('Fleet'),
    path: 'fleets'
  },
  REPORT: {
    id: 'REPORT',
    label: null,
    path: null,
    disableSort: true,
  }
}
